module.exports = "<div *ngIf=\"text\" class=\"DAG-chart-print\" (click)=\"onClick()\">\n{{text}}\n</div>\n"